import React from "react";
import Messages from "./Messages";

export const Moderation = () => (
  <Messages
    defaultStatus="flagged"
    titleOverride="Moderation Queue"
    eyebrowOverride="FLAGGED"
    subOverride="Messages flagged by automated filters or LLM. Approve, remove, or mark as spam."
    hideStatusFilter
  />
);

export default Moderation;
